// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/restaurant/food_types.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/restaurant/food_types.proto.
 */
export const file_proto_model_feature_restaurant_food_types = /*@__PURE__*/
  fileDesc("Ci9wcm90by9tb2RlbC9mZWF0dXJlL3Jlc3RhdXJhbnQvZm9vZF90eXBlcy5wcm90bxIGY2FybWVuKuUCCgxGb29kQ2F0ZWdvcnkSHQoZRk9PRF9DQVRFR09SWV9VTlNQRUNJRklFRBAAEhcKE0ZPT0RfQ0FURUdPUllfREFJUlkQARIZChVGT09EX0NBVEVHT1JZX1NFQUZPT0QQAhIZChVGT09EX0NBVEVHT1JZX0FMQ09IT0wQAxIWChJGT09EX0NBVEVHT1JZX01FQVQQBBIWChJGT09EX0NBVEVHT1JZX05VVFMQBRIYChRGT09EX0NBVEVHT1JZX0dMVVRFThAGEhkKFUZPT0RfQ0FURUdPUllfTEFDVE9TRRAHEhkKFUZPT0RfQ0FURUdPUllfUEVBTlVUUxAIEhUKEUZPT0RfQ0FURUdPUllfU09ZEAkSFwoTRk9PRF9DQVRFR09SWV9XSEVBVBAKEhoKFkZPT0RfQ0FURUdPUllfUkVEX01FQVQQCxIbChdGT09EX0NBVEVHT1JZX1NIRUxMRklTSBAMKq0BChBBbGxlcmdlblNldmVyaXR5EiEKHUFMTEVSR0VOX1NFVkVSSVRZX1VOU1BFQ0lGSUVEEAASGgoWQUxMRVJHRU5fU0VWRVJJVFlfTUlMRBABEh4KGkFMTEVSR0VOX1NFVkVSSVRZX01PREVSQVRFEAISHAoYQUxMRVJHRU5fU0VWRVJJVFlfU0VWRVJFEAMSHAoYQUxMRVJHRU5fU0VWRVJJVFlfTEVUSEFMEARCO1o5Z2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvZmVhdHVyZS9yZXN0YXVyYW50YgZwcm90bzM");

/**
 * Describes the enum carmen.FoodCategory.
 */
export const FoodCategorySchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_restaurant_food_types, 0);

/**
 * @generated from enum carmen.FoodCategory
 */
export const FoodCategory = /*@__PURE__*/
  tsEnum(FoodCategorySchema);

/**
 * Describes the enum carmen.AllergenSeverity.
 */
export const AllergenSeveritySchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_restaurant_food_types, 1);

/**
 * Allergy-specific severity levels for medical and safety contexts
 *
 * @generated from enum carmen.AllergenSeverity
 */
export const AllergenSeverity = /*@__PURE__*/
  tsEnum(AllergenSeveritySchema);

